import * as React from 'react'
import { Spinner } from '../spinner/Spinner';


export interface LoaderProps<T> {
  withT: (t: T) => JSX.Element;
  loadT: () => Promise<T>;
  key: string;
}

export class Loader<T> extends React.Component<LoaderProps<T>, {
  t?: T;
}>{
  private myIsMounted: boolean = false;

  public constructor(props: LoaderProps<T>) {
    super(props);
    this.state = {};
  }

  public componentDidMount(): void {
    this.myIsMounted = true;
    this.props.loadT().then((t) => {
      if (!this.myIsMounted) {
        return;
      }
      this.setState({t})
    });
  }

  public componentWillMount(): void {
    this.myIsMounted = false
  }

  public render() {
    if (!this.state.t) {
      return <Spinner/>;
    }
    return this.props.withT(this.state.t);
  }
}
